import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Ответ FAQ из каталога: строка через `\n` — абзац, подряд идущие строки `- …` — один маркированный список. */
function FaqAnswer({ text }: { text: string }) {
  const blocks: (string | string[])[] = [];
  for (const line of text.split('\n')) {
    const item = /^- (.*)/.exec(line)?.[1];
    const last = blocks[blocks.length - 1];
    if (item === undefined) blocks.push(line);
    else if (Array.isArray(last)) last.push(item);
    else blocks.push([item]);
  }
  return (
    <div className="txt">
      {blocks.map((block, i) =>
        Array.isArray(block) ? (
          <ul key={i}>
            {block.map((li, j) => (
              <li key={j}>{li}</li>
            ))}
          </ul>
        ) : (
          <p key={i}>{block}</p>
        ),
      )}
    </div>
  );
}

/** Частые вопросы (`section#faq` макета): аккордеон, первый вопрос открыт по умолчанию. */
export function Faq() {
  const { t } = useTranslation('landing');
  const items = t('faq.items', { returnObjects: true }) as { q: string; a: string }[];
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="sec s-wine round" id="faq" style={{ paddingBottom: 140 }}>
      <div className="wrap">
        <h2 className="h2 rv">{t('faq.title')}</h2>
        <div className="faq">
          {items.map((item, i) => (
            <div className={i === openIndex ? 'q rv open' : 'q rv'} key={i}>
              <button type="button" onClick={() => setOpenIndex(i === openIndex ? -1 : i)}>
                {item.q}
                <i className="pm" />
              </button>
              <div className="a">
                <div>
                  <FaqAnswer text={item.a} />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="faq-cta rv">
          <Link className="rulesbtn big light" to="/rules" data-rules="">
            <svg className="docic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
              <path d="M14 3v5h5M9 13h6M9 17h4" />
            </svg>
            {t('faq.ctaRules')}
            <span className="ar">↗</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
